import React, { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import ReactTable from "components/framework/table/ReactTable";
import { getValueOrEmpty } from "services/util/StringUtil";
import { BillingTypes } from "components/manage/types/BillingTypes";
import BillingActionCell from "./BillingActionsCell";

type Props = {
  billingReports: BillingTypes[];
  billingLoaded: boolean;
  feeTierId?: string;
};

export default function ExploreFeesCard(props: Props) {
  const intl = useIntl();
  const [selectedFeeTierId, setSelectedFeeTierId] = useState<string | undefined>();

  const columns = useMemo(
    () => [
      {
        Header: intl.formatMessage({ id: "manage.billing.table.lookuptype" }),
        accessor: "lookupType",
        Cell: (cell: any) => getValueOrEmpty(cell.cell.value)
      },
      {
        Header: intl.formatMessage({ id: "manage.billing.table.includedquantity" }),
        accessor: "includedQuantity",
        Cell: (cell: any) => getValueOrEmpty(cell.cell.value)
      },
      {
        Header: intl.formatMessage({ id: "manage.billing.table.unitprice" }),
        accessor: "unitPrice",
        Cell: (cell: any) => getValueOrEmpty(cell.cell.value)
      },
      {
        Header: intl.formatMessage({ id: "manage.billing.table.cap" }),
        accessor: "cap",
        Cell: (cell: any) => getValueOrEmpty(cell.cell.value)
      },
      {
        id: "expander",
        Header: intl.formatMessage({ id: "manage.billing.table.overageprice" }),
        accessor: "overagePrice",
        Cell: (cell: any) => getValueOrEmpty(cell.cell.value)
      },
      {
        Header: intl.formatMessage({ id: "manage.billing.table.actions" }),
        accessor: "actions",
        Cell: ({ row }: any) => (
          <BillingActionCell
            billing={row.original}
            key={row.original.id}
            feeTierId={selectedFeeTierId}
          />
        )
      }
    ],
    [intl]
  );

  return (
    <ReactTable
      data={props.billingReports}
      hideSearch={true}
      columns={columns}
      isTableLoading={!props.billingLoaded}
    />
  );
}
